import { render } from "./alternative_verification.html?vue&type=template&id=b9e45bc4&scoped=true&external"
import script from "./alternative_verification.js?vue&type=script&lang=js&external"
export * from "./alternative_verification.js?vue&type=script&lang=js&external"

import "./AlternativeVerificationReport.vue?vue&type=style&index=0&id=b9e45bc4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9e45bc4"]])

export default __exports__